import { registerSystem } from "yage/components/ComponentRegistry";
import { System } from "yage/components/System";
import { EnemyTypeSchema, PlayerTypeSchema } from "yage/components/entity/Types";
import { Component, defaultValue, Schema, type } from "yage/decorators/type";
import { GameModel } from "yage/game/GameModel";
import { ChildSchema } from "yage/schemas/entity/Child";

@Component("BurnTickEnhancer")
export class BurnTickEnhancerSchema extends Schema {
  @type("number")
  burnTickScale: number;
}

class BurnTickEnhancerSystem implements System {
  schema = BurnTickEnhancerSchema;
  type = "BurnTickEnhancer";
  dependencies = ["Child"];
  init(entity: number, gameModel: GameModel) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (!gameModel.hasComponent(parent, "BurnTickEnhancer")) {
        gameModel.addComponent(parent, BurnTickEnhancerSchema, {
          burnTickScale: 1,
        });
      }
      gameModel.getTypedUnsafe(parent, BurnTickEnhancerSchema).burnTickScale += gameModel.getTypedUnsafe(
        entity,
        BurnTickEnhancerSchema
      ).burnTickScale;
    }
  }

  cleanup(entity: number, gameModel: GameModel, ejecting: boolean) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      const parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (gameModel.hasComponent(parent, "BurnTickEnhancer")) {
        gameModel.getTypedUnsafe(parent, BurnTickEnhancerSchema).burnTickScale -= gameModel.getTypedUnsafe(
          entity,
          BurnTickEnhancerSchema
        ).burnTickScale;
      }
    }
  }
}
registerSystem(BurnTickEnhancerSystem);
